import type { Strings } from '../../i18n/strings';

// B8 (H6): the Activity log in plain words. Logged actions are either named
// events ("person_erased") or row changes written by triggers
// ("insert:role_grants"). Unknown ones fall back to "Change recorded"; the
// raw code stays in the CSV export.
const TABLE_VERBS: Record<string, Partial<Record<'insert' | 'update' | 'delete', string>>> = {
  role_grants: { insert: 'role_added', update: 'role_changed', delete: 'role_removed' },
  classes: { insert: 'class_added', update: 'class_changed', delete: 'class_deleted' },
  assignments: { insert: 'assignment_added', update: 'assignment_changed', delete: 'assignment_ended' },
  class_messages: { insert: 'reply_posted', update: 'reply_changed' },
  school_messages: { insert: 'reply_posted', update: 'reply_changed' },
  schools: { insert: 'school_settings_changed', update: 'school_settings_changed' },
};

export function activityLabel(t: Strings, action: string, details?: Record<string, unknown>): string {
  let key = action;
  const m = /^(insert|update|delete):([a-z_]+)$/.exec(action);
  if (m) key = TABLE_VERBS[m[2]]?.[m[1] as 'insert'] ?? 'other';
  if (action === 'insight_viewed') {
    key = details?.view === 'session_results' ? 'session_results' : details?.view ? 'school_results' : 'insight_viewed';
  }
  const s = (t as unknown as Record<string, unknown>)[`r4.act.${key}`];
  return typeof s === 'string' ? s : t['r4.act.other'];
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Hide raw ids; names come from the server already. */
export function activityTarget(target: string | null | undefined): string | null {
  if (!target || UUID.test(target)) return null;
  return target;
}

export function activityActor(t: Strings, actor: string, actingRole: string | null): string {
  if (actor === 'system') return t['r4.who.system'];
  if (actingRole === 'platform_admin') return t['r4.who.support'];
  if (UUID.test(actor)) return t['r4.who.former'];
  return actor;
}
